import React, { Component } from 'react'
import { withProfile } from 'app/modules/profile'
import I18n from 'components/I18n'
import {
  profile,
  handle,
  globalHandle,
  companyUrl,
  profileUrl,
  overview,
  details,
  social,
  messaging,
  visibility,
  theme,
  profileUpdateStatusSuccess,
  profileUpdateStatusPending,
} from 'app/modules/profile/selectors'
import {
  handle as handleUI,
  globalHandle as globalHandleUI,
  overview as overviewUI,
  social as socialUI,
  details as detailsUI,
  messaging as messagingUI,
  theme as themeUI,
  isValidHandle, // deprecating...
  isHandleValid,
  isGlobalHandleValid,
  globalHandleCheckComplete,
  coverPhotoUpload,
} from 'app/modules/profile/selectorsUI'
import { hasMeetings } from 'app/modules/gates/selectors'
import OverviewInfo from './OverviewInfo'
import ContactInfo from './ContactInfo'
import MessagingInfo from './MessagingInfo'
import DetailInfo from './DetailInfo'
import ThemeInfo from './ThemeInfo'

class ProfileSection extends Component {
  componentWillMount() {
    this.props.actions.setProfileUI(this.props.profile)
  }

  render() {
    return (
      <div className="my-profile-settings-wrapper">
        <I18n>
          <OverviewInfo
            orgHandle={this.props.orgHandle}
            handle={this.props.handle}
            handleUI={this.props.handleUI}
            globalHandle={this.props.globalHandle}
            globalHandleUI={this.props.globalHandleUI}
            profile={this.props.profile}
            overview={this.props.overview}
            overviewUI={this.props.overviewUI}
            companyUrl={this.props.companyUrl}
            isValidHandle={this.props.isValidHandle}
            isHandleValid={this.props.isHandleValid}
            isGlobalHandleValid={this.props.isGlobalHandleValid}
            globalHandleCheckComplete={this.props.globalHandleCheckComplete}
            profileUpdateStatusSuccess={this.props.profileUpdateStatusSuccess}
            profileUpdateStatusPending={this.props.profileUpdateStatusPending}
            visibility={this.props.visibility}
            actions={this.props.actions}
          />
          <ThemeInfo
            theme={this.props.theme}
            themeUI={this.props.themeUI}
            coverPhotoUpload={this.props.coverPhotoUpload}
            user={this.props.user}
            actions={this.props.actions}
          />
          <ContactInfo
            social={this.props.social}
            socialUI={this.props.socialUI}
            actions={this.props.actions}
            hasMeetings={this.props.hasMeetings}
          />
          <MessagingInfo
            messaging={this.props.messaging}
            messagingUI={this.props.messagingUI}
            actions={this.props.actions}
          />
          <DetailInfo
            details={this.props.details}
            detailsUI={this.props.detailsUI}
            actions={this.props.actions}
          />
        </I18n>
      </div>
    )
  }
}

export default withProfile(
  {
    handle,
    handleUI,
    globalHandle,
    globalHandleUI,
    profile,
    profileUrl,
    companyUrl,
    overview,
    overviewUI,
    isValidHandle,
    isHandleValid,
    isGlobalHandleValid,
    globalHandleCheckComplete,
    profileUpdateStatusSuccess,
    profileUpdateStatusPending,
    social,
    socialUI,
    details,
    detailsUI,
    messaging,
    messagingUI,
    visibility,
    theme,
    themeUI,
    coverPhotoUpload,
    hasMeetings,
  },
  { blocking: true }
)(ProfileSection)



// WEBPACK FOOTER //
// ./src/scripts/components/settings/UserProfile/Sections/Profile/index.js